import { render, staticRenderFns } from "./UserConfirm.vue?vue&type=template&id=6e2b44e0&"
import script from "./UserConfirm.vue?vue&type=script&lang=js&"
export * from "./UserConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports